import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import { timeAgo } from "@/lib/format";
import { PageLoader, EmptyState, ErrorState } from "@/components/common";
import { Bell } from "lucide-react";

export default function Notices() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { data: notices, isLoading, isError, refetch } = useQuery({ queryKey: ["notices"], queryFn: () => apiFetch("/notices") });

  useEffect(() => {
    apiFetch("/notices/read", { method: "POST" }).then(() => {
      qc.invalidateQueries({ queryKey: ["notif-summary"] });
    }).catch(() => {});
  }, [qc]);

  if (isLoading) return <PageLoader />;
  if (isError) return <ErrorState onRetry={refetch} />;

  return (
    <div className="mx-auto max-w-2xl px-4 py-8 sm:px-6">
      <h1 className="font-display text-2xl font-extrabold">Notifications</h1>
      <div className="mt-6 space-y-2">
        {notices.length === 0 ? (
          <EmptyState icon={Bell} title="No notifications" message="You're all caught up." />
        ) : (
          notices.map((n) => (
            <button
              key={n.id}
              data-testid={`notice-${n.id}`}
              onClick={() => n.link && navigate(n.link)}
              className={`flex w-full items-start gap-3 rounded-2xl border border-border p-4 text-left transition hover:bg-secondary ${!n.read ? "bg-price-soft/40" : ""}`}
            >
              <div className={`mt-1 h-2 w-2 shrink-0 rounded-full ${n.read ? "bg-transparent" : "bg-price"}`} />
              <div className="flex-1">
                <p className="text-sm">{n.text}</p>
                <p className="mt-0.5 text-xs text-muted-foreground">{timeAgo(n.created_at)}</p>
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  );
}
